/**
 * The wirehouse list's words (SR-416 block 3's lists; the block 2 plan's B2-7) — what an edit to it
 * reaches, said wherever it is changed (Team routing's Routing, SR-513).
 */

/**
 * What an edit reaches, and when — survey-api's rule (the firm lists design's §6), in words: an
 * edit pins nothing and moves no response; each participant meets it at the next thing that reads
 * the list for them.
 */
export const FIRM_LIST_REACH =
  'An edit moves no response and re-routes nobody at once. A participant already read against ' +
  'the list meets it at their next BrokerCheck answer or the next survey started; a team with no ' +
  'such answer, the next time its routing is read; every Teams registration after the edit is ' +
  'asked by the new list.';
